export const sendNewRelicEventOnError = (url, data, error) => {
  if (typeof window !== 'undefined' && typeof window?.newrelic == 'object') {
    const statusCode = data?.httpStatus;
    if (statusCode && statusCode !== '200' && statusCode !== '204') {
      window?.newrelic.noticedata(JSON.stringify({ ...data, url: url }));
    } else if (error) {
      window?.newrelic.noticedata(JSON.stringify({ data: JSON.stringify(error), url: url }));
    }
  }
};